import * as M from '@mantine/core';

import { AI_AGENT_HISTORY_TYPE_LABELS } from '../../../../../../../shared/constants/typeOptions';
import { handleChangeLocaleTime } from '../../../../../../../shared/utils/time';
import HoverCardText from '../../../../../../ui/hoverCardText';

import type { IManualHistory } from '../../../../../../../shared/apis/ai-agent/manual/types';
import type { ApiResponse } from '../../../../../../../shared/types/response/types';

interface IManualHistoryTableProps {
  history?: ApiResponse<IManualHistory>;
  page: number;
  size: number;
  isLoading: boolean;
  isError: boolean;
  onPageChange: (page: number) => void;
}

const TABLE_COLUMN_COUNT = 11;

export default function ManualHistoryTable(props: IManualHistoryTableProps) {
  const { history, page, size, isLoading, isError, onPageChange } = props;
  const data = history?.result || [];
  const totalCount = history?.count || 0;

  return (
    <M.Box>
      <M.Text fw={600} mb="sm">
        매뉴얼 설정 이력
      </M.Text>
      <M.Table.ScrollContainer minWidth={1000}>
        <M.Table>
          <M.Table.Thead>
            <M.Table.Tr>
              <M.Table.Th>번호</M.Table.Th>
              <M.Table.Th>등록 서비스</M.Table.Th>
              <M.Table.Th>구분</M.Table.Th>
              <M.Table.Th>수정 담당자</M.Table.Th>
              <M.Table.Th>학습 페이지수</M.Table.Th>
              <M.Table.Th>변동된 기계모델명</M.Table.Th>
              <M.Table.Th>SCAUTR 파일 적용</M.Table.Th>
              <M.Table.Th>PROGIX 파일 적용</M.Table.Th>
              <M.Table.Th>PRO-DOQ 파일 적용</M.Table.Th>
              <M.Table.Th>비고</M.Table.Th>
              <M.Table.Th>최종 수정일시</M.Table.Th>
            </M.Table.Tr>
          </M.Table.Thead>
          <M.Table.Tbody>
            {isLoading ? (
              <M.Table.Tr>
                <M.Table.Td colSpan={TABLE_COLUMN_COUNT}>
                  <M.Flex justify="center" py="xl">
                    <M.Loader size="sm" />
                  </M.Flex>
                </M.Table.Td>
              </M.Table.Tr>
            ) : isError ? (
              <M.Table.Tr>
                <M.Table.Td colSpan={TABLE_COLUMN_COUNT}>
                  <M.Text ta="center" c="red.6" size="sm" py="xl">
                    매뉴얼 설정 이력을 불러오지 못했습니다.
                  </M.Text>
                </M.Table.Td>
              </M.Table.Tr>
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <M.Table.Tr key={item.id}>
                  <M.Table.Td>{totalCount - ((page - 1) * size + index)}</M.Table.Td>
                  <M.Table.Td>{item.regServiceChannel}</M.Table.Td>
                  <M.Table.Td>{AI_AGENT_HISTORY_TYPE_LABELS[item.historyType] || item.historyType}</M.Table.Td>
                  <M.Table.Td ta="left">{item.regId}</M.Table.Td>
                  <M.Table.Td>{item.pageCount}</M.Table.Td>
                  <M.Table.Td>{item.modelChangeContent || '-'}</M.Table.Td>
                  <M.Table.Td>{item.scautrUseYn === 'Y' ? '적용' : '미적용'}</M.Table.Td>
                  <M.Table.Td>{item.progixUseYn === 'Y' ? '적용' : '미적용'}</M.Table.Td>
                  <M.Table.Td>{item.useYn === 'Y' ? '적용' : '미적용'}</M.Table.Td>
                  <M.Table.Td ta="left" maw={240}>
                    <HoverCardText value={item.remark || '-'} />
                  </M.Table.Td>
                  <M.Table.Td>{handleChangeLocaleTime(item.regDt)}</M.Table.Td>
                </M.Table.Tr>
              ))
            ) : (
              <M.Table.Tr>
                <M.Table.Td colSpan={TABLE_COLUMN_COUNT}>
                  <M.Text ta="center" c="gray.6" size="sm" py="xl">
                    조회된 이력이 없습니다.
                  </M.Text>
                </M.Table.Td>
              </M.Table.Tr>
            )}
          </M.Table.Tbody>
        </M.Table>
      </M.Table.ScrollContainer>
      {!isLoading && !isError && totalCount > 0 && (
        <M.Group mt="md" justify="center">
          <M.Pagination total={Math.ceil(totalCount / size)} value={page} onChange={onPageChange} />
        </M.Group>
      )}
    </M.Box>
  );
}
